import { useFlag } from '@automata/utils/hooks';

import { GrantAccess } from 'components/GrantAccess';
import { PermissionsEnum } from 'model/User';
import { CanvasWorkflowsList } from 'screens/CanvasWorkflowsScreen';

export default function CanvasWorkflowsListPage() {
  const isCanvasAppEnabled = useFlag('fe.canvas-builder');

  if (!isCanvasAppEnabled) return null;

  return (
    <GrantAccess permissionsNeeded={PermissionsEnum.RUN_RESOURCES}>
      <CanvasWorkflowsList />
    </GrantAccess>
  );
}
